import React, { useEffect, useState } from "react";
import PageHero from "../components/PageHero";
import { EditableText } from "../components/live/Editable";
import api from "../lib/api";
import { UsersRound } from "lucide-react";

export default function FacultyPage() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/faculty", { params: { active_only: true } }).then((r) => setItems(r.data));
  }, []);

  const principal = items.find((f) => (f.role || "").toLowerCase().includes("principal"));
  const rest = items.filter((f) => f !== principal);

  return (
    <>
      <PageHero
        path="faculty.hero"
        kicker="Faculty"
        title="Faculty for our Training Institute"
        subtitle="The success of our students depends on the strength of our faculty. Faculty at Kiki Centre for Technology is well qualified and extremely well trained to deliver courses as per industry requirements — consisting of German and Indian experts from academia and industry."
      />
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          {principal && (
            <div
              className="mb-12 grid md:grid-cols-[280px_1fr] gap-0 rounded-3xl overflow-hidden border border-slate-100 shadow-lg bg-white animate-fade-up"
              data-testid="faculty-principal"
            >
              <div className="aspect-square md:aspect-auto md:h-full overflow-hidden bg-slate-100">
                <img src={principal.image_url} alt={principal.name} className="w-full h-full object-cover" />
              </div>
              <div className="p-8 flex flex-col justify-center bg-[#0B2A6B] text-white">
                <span className="inline-block w-fit px-3 py-1 rounded-full bg-yellow-400 text-[#0B2A6B] text-[11px] font-bold uppercase tracking-wider mb-4">
                  {principal.role}
                </span>
                <h2 className="text-3xl font-bold mb-3">{principal.name}</h2>
                <p className="text-slate-200 leading-relaxed max-w-2xl">{principal.bio}</p>
              </div>
            </div>
          )}

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
            {rest.map((f, i) => (
              <div
                key={f.id}
                className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl border border-slate-100 tilt-card animate-fade-up"
                style={{ animationDelay: `${i * 0.06}s` }}
              >
                <div className="aspect-square overflow-hidden">
                  <img src={f.image_url} alt={f.name} className="w-full h-full object-cover zoom-img" />
                </div>
                <div className="p-5">
                  <h3 className="font-bold text-[#0B2A6B] text-lg">{f.name}</h3>
                  <p className="text-sm text-yellow-600 font-semibold mb-2">{f.role}</p>
                  <p className="text-sm text-slate-600 leading-relaxed">{f.bio}</p>
                </div>
              </div>
            ))}
            {[
              { name: "Team Members", role: "Team Electrical / Electronics", icon: "electrical" },
              { name: "Team Members", role: "Team Mechanical", icon: "mechanical" },
            ].map((t) => (
              <div
                key={t.role}
                className="bg-[#0B2A6B] rounded-2xl overflow-hidden shadow-sm border border-slate-100 tilt-card animate-fade-up flex flex-col"
                data-testid={`faculty-team-${t.icon}`}
              >
                <div className="aspect-square flex items-center justify-center bg-[#08205a]">
                  <UsersRound className="h-24 w-24 text-yellow-400/70" />
                </div>
                <div className="p-5">
                  <EditableText path={`faculty.team.${t.icon}.name`} as="h3" className="font-bold text-white text-lg block">{t.name}</EditableText>
                  <EditableText path={`faculty.team.${t.icon}.role`} as="p" className="text-sm text-yellow-400 font-semibold mb-2 block">{t.role}</EditableText>
                  <EditableText path={`faculty.team.${t.icon}.bio`} as="p" multiline className="text-sm text-slate-300 leading-relaxed block">
                    A dedicated team of trainers delivering hands-on instruction across our workshops and labs.
                  </EditableText>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
